var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.area)?_c('div',[(_vm.loadingCrags)?_c('v-skeleton-loader',{staticClass:"mb-3",attrs:{"type":"text, text, text"}}):_vm._e(),_vm._v(" "),(!_vm.loadingCrags)?_c('area-crags',{attrs:{"crags-data":_vm.crags,"area":_vm.area}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }